const shuffle = require('lodash/shuffle');
const partition = require('lodash/partition');

function randomizeOptions(slideObject) {
  const slideOptions = partition(slideObject.options, option => !option.id.match(/Other/i));

  return [...shuffle(slideOptions[0] || []), ...slideOptions[1]];
}

module.exports = randomizeOptions;